// @ts-nocheck
import { __assign, __rest } from "tslib";
import './TagGroup.css';
import React from 'react';
import { cn } from '../../utils/bem';
import { Tag } from '../Tag/Tag';
var cnTagGroup = cn('TagGroup');
export var TagGroup = React.forwardRef(function (props, ref) {
    var _a = props.gap, gap = _a === void 0 ? 'm' : _a, _b = props.mode, mode = _b === void 0 ? 'link' : _b, _c = props.size, size = _c === void 0 ? 's' : _c, items = props.items, otherProps = __rest(props, ["gap", "mode", "size", "items"]);
    return (React.createElement("div", __assign({ ref: ref }, otherProps, { className: cnTagGroup({
            gap: gap
        }) }), items.map(function (item) { return (React.createElement(Tag, __assign({}, item, { mode: mode, size: size, key: item.id, label: item.title }))); })));
});
